module.exports = __webpack_public_path__ + "img/portrait-071.e9b360c7.jpg";